import { useContext, useEffect, useMemo } from 'react';
import BukIntegrationContent from './BukIntegrationContent';
import MercadoPagoIntegrationContent from './MercadoPagoIntegrationContent';
import Global66IntegrationContent from './Global66IntegrationContent';
import IntegrationAccordion from './IntegrationAccordion';
import { useIntegrationStatus } from '../../../../../../pages/useAdministracion.hooks';
import { IntegrationsAPI } from '../../../../../../api/integrations.api';
import GlobalContext from '../../../../../../context/global-context';
import PlanRestrictedContent from '../../../../ui/PlanRestrictedContent';
import { SHOW_NEW_GLOBAL66_BANK } from '../../../../../utils/constant';

const Integraciones = () => {
  const { currentBusiness } = useContext(GlobalContext);
  const { status: integrationStatus, setStatus, setLoading, setError } = useIntegrationStatus();
  const integrationsAPI = useMemo(() => new IntegrationsAPI(), []);

  useEffect(() => {
    const fetchIntegrationStatus = async () => {
      if (!currentBusiness?.id) return;

      try {
        setLoading(true);
        const response = await integrationsAPI.getIntegrationsStatus(currentBusiness.id);
        setStatus(response.data);
      } catch (error) {
        console.error('Error fetching integration status:', error);
        setError(error?.response?.data?.message || 'Error al obtener estado de integraciones');
      }
    };

    fetchIntegrationStatus();
  }, [currentBusiness?.id, integrationsAPI, setStatus, setLoading, setError]);

  const getBadge = (isIntegrated) => {
    return isIntegrated
      ? { text: 'INTEGRADO', className: 'bg-green-100 text-green-700' }
      : { text: 'NO INTEGRADO AÚN', className: 'bg-gray-300 text-gray-600' };
  };

  const bukBadge = getBadge(integrationStatus?.buk?.integrated);
  const mercadoPagoBadge = getBadge(integrationStatus?.mercadopago?.integrated);
  const global66Badge = getBadge(integrationStatus?.global66?.integrated);

  return (
    <div className="p-6 space-y-4 font-sans">
      <IntegrationAccordion title="BUK" defaultOpen={true} badge={bukBadge}>
        <PlanRestrictedContent
          requiredPermission="allowBukIntegration"
          message="La integración con BUK no está disponible en tu plan actual. Actualiza tu plan para acceder a esta funcionalidad."
        >
          <BukIntegrationContent isModal={false} />
        </PlanRestrictedContent>
      </IntegrationAccordion>

      <IntegrationAccordion title="Mercado Pago" badge={mercadoPagoBadge}>
        <PlanRestrictedContent
          requiredPermission="allowMercadopagoIntegration"
          message="La integración con Mercado Pago no está disponible en tu plan actual. Actualiza tu plan para acceder a esta funcionalidad."
          canAddAddon={true}
        >
          <MercadoPagoIntegrationContent />
        </PlanRestrictedContent>
      </IntegrationAccordion>

      {SHOW_NEW_GLOBAL66_BANK && (
        <IntegrationAccordion title="Global66" badge={global66Badge}>
          <Global66IntegrationContent
            onStatusChange={(integrated, initialBalance) =>
              setStatus({
                ...integrationStatus,
                global66: {
                  integrated,
                  initialBalance: initialBalance ?? integrationStatus?.global66?.initialBalance ?? null,
                },
              })
            }
          />
        </IntegrationAccordion>
      )}
    </div>
  );
};

export default Integraciones;
